import { ComponentMap } from '@cinch-nx/data-storyblok'
import { landingStoryblokComponents } from '@cinch-nx/landing-ui-shared'
import { PreFooterCtaV2Wrapper } from '../../components/pre-footer-cta-v2-wrapper'
import { SectionWithImageV2Wrapper } from '../../components'
import { SiteLocation } from '../../components/site-location'
import { NearbyLocations } from '../../components/nearby-locations/nearby-locations'

const localStoryblokComponents: ComponentMap = {
  SectionWithImageV2: SectionWithImageV2Wrapper,
  PreFooterCtaV2: PreFooterCtaV2Wrapper,
  SiteLocation: SiteLocation,
  NearbyLocations: NearbyLocations,
}

export const storyblokComponentsCollections: ComponentMap = {
  ...landingStoryblokComponents,
  ...localStoryblokComponents,
}
